import React, { useContext } from 'react';
import { Result, Button, Typography } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

import { Context } from '../../../defaults';

const NoAccess = () => {
    const { dictionary, language } = useContext(Context);
    const { Paragraph, Text } = Typography;
    return (
        <Result
            status='error'
            title={`${dictionary?.NoAccess[language]}`}
            subTitle={`${dictionary?.NoAccessSub[language]}`}
            extra={
                <Button
                    onClick={
                        () => {
                            window.location.href = '/message';
                        }
                    }
                >
                    {dictionary?.SendMessage[language]}
                </Button>
            }
        >
            {/* <div className="desc">
                <Paragraph>
                    <Text
                        strong
                        style={{ fontSize: 16 }}
                    >
                        The content you submitted has the following error:
            </Text>
                </Paragraph>
                <Paragraph>
                    <CloseCircleOutlined className="site-result-demo-error-icon" /> Your account has been
            frozen. <a>Thaw immediately &gt;</a>
                </Paragraph>
                <Paragraph>
                    <CloseCircleOutlined className="site-result-demo-error-icon" /> Your account is not yet
            eligible to apply. <a>Apply Unlock &gt;</a>
                </Paragraph>
            </div> */}
        </Result>
    );
}

export default NoAccess;